import {
  CreateTransactionPayloadType,
  createTransactionApi,
} from '@/api/v1/organization/contracts/createTransactionApi';
import { getTransactionsApi } from '@/api/v1/organization/contracts/getTransactionsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { prepareSearchFiltersListApiParams } from './helpers';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { IDEMPOTENCY_KEY, idempotencyKeyHandler } from '@/helpers/apiHelpers/requestHelpers';

export const createTransaction = async (payload: CreateTransactionPayloadType) => {
  const { header, clearKey } = idempotencyKeyHandler(IDEMPOTENCY_KEY.CREATE_TRANSACTION);

  try {
    const response = await createTransactionApi(payload, header);

    clearKey();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const loadTransactions = async (params: ApiParams) => {
  const apiParams = prepareSearchFiltersListApiParams(params);

  try {
    const response = await getTransactionsApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
